<div class="ab-list-item-inner flex w-100 activity-type--new-person">
  <span class="ab-list-item__icon">
    <i class="icon fal fa-plus"></i>
  </span>
  <div class="ab-list-item__content">
    <div class="summary">
      <span class="actor">{{item?.user?.name}}</span> added
      <app-activity-target-link [target]="item.target">{{item?.target | fullName}}</app-activity-target-link> to the campaign.
    </div>
  </div>
  <app-activity-event-timestamp [item]="item" class="ab-list-item__timestamp">
  </app-activity-event-timestamp>
</div>
